import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { wsEndpointsApi } from "@/lib/api";
import type { WebsocketEndpointCreate, WebsocketEndpointUpdate } from "@/types";

export function useWebsocketEndpoints() {
  return useQuery({
    queryKey: ["websocket-endpoints"],
    queryFn: () => wsEndpointsApi.list(),
  });
}

export function useWebsocketEndpoint(id: string) {
  return useQuery({
    queryKey: ["websocket-endpoints", id],
    queryFn: () => wsEndpointsApi.get(id),
    enabled: !!id,
  });
}

export function useCreateWebsocketEndpoint() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: WebsocketEndpointCreate) => wsEndpointsApi.create(data),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: ["websocket-endpoints"] }),
  });
}

export function useUpdateWebsocketEndpoint() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: WebsocketEndpointUpdate;
    }) => wsEndpointsApi.update(id, data),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: ["websocket-endpoints"] }),
  });
}

export function useDeleteWebsocketEndpoint() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => wsEndpointsApi.delete(id),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: ["websocket-endpoints"] }),
  });
}
